import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Form, Navbar, Nav } from 'react-bootstrap';
import './BackgroundCheckLanding.css';
import bghero from '../../assets/img/dataworker_backgroundhero.jpg'
import bc_logo from '../../assets/img/background_check_logo.png'
import { Routes } from '../../routes';
import { useHistory } from 'react-router';
import { parsedUser } from '../../common/GetCurrentUser';
const BackgroundCheckLanding: React.FC = () => {
    const [scrolled, setScrolled] = useState(false);
    const user = parsedUser();
    document.title = "Background Check";

    const history = useHistory()
    useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 10;
            setScrolled(isScrolled);
        };
        if (user) {
            history.push(Routes.Dataworkerhome.path);
        }
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (sectionId: string) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="background-check-landing">
            {/* Sticky Navigation */}
            <Navbar
                expand="lg"
                fixed="top"
                className={`custom-navbar ${scrolled ? 'scrolled' : ''}`}
            >
                <Container>
                    <Navbar.Brand href="#home" className="fw-bold fs-4 text-primary">
                        <img src={bc_logo} alt="Background Check Logo" style={{ height: '30px', marginRight: '10px' }} />
                    </Navbar.Brand>

                    <Navbar.Toggle aria-controls="basic-navbar-nav">
                        <span className="navbar-toggler-icon"></span>
                    </Navbar.Toggle>

                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto align-items-center">
                            <Nav.Link
                                href="#services"
                                className="nav-link-custom mx-2"
                                onClick={() => scrollToSection('services')}
                            >
                                Servicios
                            </Nav.Link>
                            <Nav.Link
                                href="#reports"
                                className="nav-link-custom mx-2"
                                onClick={() => scrollToSection('reports')}
                            >
                                Informes
                            </Nav.Link>
                            <Nav.Link
                                href="#contact"
                                className="nav-link-custom mx-2"
                                onClick={() => scrollToSection('contact')}
                            >
                                Contacto
                            </Nav.Link>
                            <Button
                                variant="primary"
                                size="sm"
                                className="ms-3 px-3 py-2 nav-btn"
                                onClick={() => {
                                    history.push(Routes.SignIn.path);
                                }}
                            >
                                <i className="fas fa-rocket me-2"></i>
                                Ingresar
                            </Button>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            {/* Hero Section */}
            <section id="home" className="hero-section text-white py-5 mb-0"
                style={{
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), 
                    url('${bghero}')`,

                }}
            >
                {/* <div className="hero-overlay"></div> */}
                <Container className="position-relative">
                    <Row className="align-items-center min-vh-100">
                        <Col lg={10} xl={8} className="mx-auto text-center">
                            <h1 className="hero-title mb-4">
                                Background Check
                            </h1>
                            <p className="hero-subtitle mb-4">
                                Informes de Antecedentes Judiciales<br />
                                Nacionales e Internacionales
                            </p>
                            <p className="hero-description mb-5">
                                Soluciones completas de verificación de antecedentes para empresas y organizaciones.<br />
                                Proteja su negocio con informes detallados y confiables respaldados por tecnología avanzada.
                            </p>
                            <div className="hero-buttons d-grid gap-3 d-md-flex justify-content-md-center">
                                <Button
                                    variant="light"
                                    size="lg"
                                    className="hero-btn-primary me-md-3 px-5 py-3"
                                    onClick={() => {
                                        history.push(Routes.SignIn.path);
                                    }}
                                >
                                    <i className="fas fa-rocket  me-2"></i>
                                    Ingresar
                                </Button>
                                <Button
                                    variant="outline-light"
                                    size="lg"
                                    className="hero-btn-secondary px-5 py-3"
                                    onClick={() => scrollToSection('services')}
                                >
                                    <i className="fas fa-info-circle me-2"></i>
                                    Más Información
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Services Overview */}
            <section id="services" className="services-section py-5 bg-light">
                <Container>
                    <Row>
                        <Col lg={12} className="text-center mb-5">
                            <h2 className="display-2 fw-bold text-primary mb-3">
                                Nuestros Servicios
                            </h2>
                            <p className="lead text-muted">
                                Verificación integral de antecedentes con tecnología avanzada
                            </p>
                        </Col>
                    </Row>
                    <Row className="g-4">
                        <Col md={6} lg={4}>
                            <Card className="h-100 border-0 shadow-sm">
                                <Card.Body className="text-center p-4">
                                    <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                                        style={{ width: '80px', height: '80px' }}>
                                        <i className="fas fa-gavel text-primary fa-2x"></i>
                                    </div>
                                    <h5 className="fw-bold mb-3">Antecedentes Judiciales</h5>
                                    <p className="text-muted">
                                        Informes detallados de antecedentes judiciales nacionales e internacionales
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6} lg={4}>
                            <Card className="h-100 border-0 shadow-sm">
                                <Card.Body className="text-center p-4">
                                    <div className="bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                                        style={{ width: '80px', height: '80px' }}>
                                        <i className="fas fa-shield-alt text-success fa-2x"></i>
                                    </div>
                                    <h5 className="fw-bold mb-3">Validación de Identidad</h5>
                                    <p className="text-muted">
                                        Verificación completa de identidad y validación de curriculum vitae
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6} lg={4}>
                            <Card className="h-100 border-0 shadow-sm">
                                <Card.Body className="text-center p-4">
                                    <div className="bg-warning bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                                        style={{ width: '80px', height: '80px' }}>
                                        <i className="fas fa-exclamation-triangle text-warning fa-2x"></i>
                                    </div>
                                    <h5 className="fw-bold mb-3">Infracciones Precedentes</h5>
                                    <p className="text-muted">
                                        Informes de vinculación con infracciones y delitos precedentes
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Report Types */}
            <section id="reports" className="reports-section py-5">
                <Container>
                    <Row>
                        <Col lg={12} className="text-center mb-5">
                            <h2 className="display-2 fw-bold text-primary mb-3">
                                Tipos de Informes
                            </h2>
                            <p className="lead text-muted">
                                Informes especializados para diferentes necesidades
                            </p>
                        </Col>
                    </Row>
                    <Row className="g-4">
                        <Col md={6}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-start">
                                        <div className="bg-primary bg-opacity-10 rounded p-3 me-3">
                                            <i className="fas fa-briefcase text-primary fa-lg"></i>
                                        </div>
                                        <div>
                                            <h5 className="fw-bold mb-2">Antecedentes Laborales</h5>
                                            <p className="text-muted mb-0">
                                                Verificación completa del historial laboral y referencias profesionales
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-start">
                                        <div className="bg-danger bg-opacity-10 rounded p-3 me-3">
                                            <i className="fas fa-balance-scale text-danger fa-lg"></i>
                                        </div>
                                        <div>
                                            <h5 className="fw-bold mb-2">Antecedentes Judiciales</h5>
                                            <p className="text-muted mb-0">
                                                Búsqueda exhaustiva en bases de datos judiciales nacionales e internacionales
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-start">
                                        <div className="bg-warning bg-opacity-10 rounded p-3 me-3">
                                            <i className="fas fa-users text-warning fa-lg"></i>
                                        </div>
                                        <div>
                                            <h5 className="fw-bold mb-2">Participación Delitos Precedentes</h5>
                                            <p className="text-muted mb-0">
                                                Análisis de participación en actividades delictivas anteriores
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-start">
                                        <div className="bg-info bg-opacity-10 rounded p-3 me-3">
                                            <i className="fas fa-chart-bar text-info fa-lg"></i>
                                        </div>
                                        <div>
                                            <h5 className="fw-bold mb-2">Datos Demográficos</h5>
                                            <p className="text-muted mb-0">
                                                Información demográfica completa y perfil en línea detallado
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Contact Section */}
            <section id="contact" className="contact-section py-5 bg-light">
                <Container>
                    <Row>
                        <Col lg={12} className="text-center mb-5">
                            <h2 className="display-2 fw-bold text-primary mb-3">
                                Contáctanos
                            </h2>
                            <p className="lead text-muted">
                                ¿Listo para proteger tu organización? Contáctanos hoy
                            </p>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <Card className="border-0 shadow">
                                <Card.Body className="p-5">
                                    <Form>
                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Nombre Completo</Form.Label>
                                                    <Form.Control type="text" placeholder="Ingrese su nombre completo" />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Email</Form.Label>
                                                    <Form.Control type="email" placeholder="Ingrese su email" />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Empresa</Form.Label>
                                                    <Form.Control type="text" placeholder="Nombre de su empresa" />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Teléfono</Form.Label>
                                                    <Form.Control type="tel" placeholder="Número de teléfono" />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Form.Group className="mb-4">
                                            <Form.Label>Mensaje</Form.Label>
                                            <Form.Control as="textarea" rows={4} placeholder="Cuéntanos sobre tus necesidades de verificación de antecedentes" />
                                        </Form.Group>
                                        <div className="text-center">
                                            <Button variant="primary" size="lg" type="submit" className="px-5">
                                                <i className="fas fa-paper-plane me-2"></i>
                                                Enviar Mensaje
                                            </Button>
                                        </div>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Footer */}
            <footer className="bg-dark text-white py-5">
                <Container>
                    <Row>
                        <Col lg={4} className="mb-4">
                            <h5 className="fw-bold mb-3">Background Check</h5>
                            <p className="text-light opacity-75">
                                Líder en servicios de verificación de antecedentes con tecnología avanzada y
                                cobertura nacional e internacional.
                            </p>
                        </Col>
                        <Col lg={4} className="mb-4">
                            <h5 className="fw-bold mb-3">Servicios</h5>
                            <ul className="list-unstyled">
                                <li className="mb-2"><a href="#" className="text-light text-decoration-none opacity-75">Antecedentes Judiciales</a></li>
                                <li className="mb-2"><a href="#" className="text-light text-decoration-none opacity-75">Validación de Identidad</a></li>
                                <li className="mb-2"><a href="#" className="text-light text-decoration-none opacity-75">Antecedentes Laborales</a></li>
                                <li className="mb-2"><a href="#" className="text-light text-decoration-none opacity-75">Datos Demográficos</a></li>
                            </ul>
                        </Col>
                        <Col lg={4} className="mb-4 d-none">
                            <h5 className="fw-bold mb-3">Contacto</h5>
                            <ul className="list-unstyled">
                                <li className="mb-2">
                                    <i className="fas fa-phone me-2"></i>
                                    <span className="text-light opacity-75">+1 (809) 123-4567</span>
                                </li>
                                <li className="mb-2">
                                    <i className="fas fa-envelope me-2"></i>
                                    <span className="text-light opacity-75">info@backgroundcheck.com</span>
                                </li>
                                <li className="mb-2">
                                    <i className="fas fa-map-marker-alt me-2"></i>
                                    <span className="text-light opacity-75">Santo Domingo, República Dominicana</span>
                                </li>
                            </ul>
                        </Col>
                    </Row>
                    <hr className="my-4 opacity-25" />
                    <Row>
                        <Col lg={12} className="text-center">
                            <p className="mb-0 text-light opacity-75">
                                &copy; 2025 Background Check. Todos los derechos reservados.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </div>
    );
};

export default BackgroundCheckLanding;
